import { useMe } from '@salescore/client-common'
import type { ViewQueryList, ViewQueryRecordNode } from '@salescore/core'
import { GOAL_MODEL_NAME } from '@salescore/features'
import { organizationHasFeature } from '@salescore/frontend-common'
import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'

import type { SheetSystemColumn } from '../domain/column'
import { pickedIdsAtom } from '../recoil/records/atoms'

export const ROW_INDEX_COLUMN_WIDTH = 28

export const useSheetSystemColumns = (query: ViewQueryList): Array<SheetSystemColumn<ViewQueryRecordNode>> => {
  const pickedIds = useRecoilValue(pickedIdsAtom)
  const { organization } = useMe()
  // NOTE: NX様専用フラグ(システムカラムからcheckboxのカラムを除外するために使用)、indexのずれによるデグレ等を嫌いwidthを0で実現
  const enableNxOnlyFeature = organizationHasFeature(organization, 'enable_nx_only_feature')

  return useMemo((): Array<SheetSystemColumn<ViewQueryRecordNode>> => {
    const node = query.tree
    const isGoalView = node.name === GOAL_MODEL_NAME

    return [
      {
        columnType: 'sheet_system',
        index: 0,
        configIndex: undefined,
        isSystem: true,
        node,
        key: `rowIndex`,
        width: ROW_INDEX_COLUMN_WIDTH,
        type: `rowIndex`,
        value: (): void => {
          // empty
        },
      },
      {
        columnType: 'sheet_system',
        index: 1,
        configIndex: undefined,
        isSystem: true,
        node,
        key: `checkbox`,
        width: isGoalView || enableNxOnlyFeature ? 0 : 38,
        type: `rowCheckbox`,
        value: (record: ViewQueryRecordNode): boolean =>
          record.id === undefined ? false : pickedIds.includes(record.id),
      },
      {
        columnType: 'sheet_system',
        index: 2,
        configIndex: undefined,
        isSystem: true,
        node,
        key: `open`,
        width: isGoalView || enableNxOnlyFeature ? 0 : 38,
        type: `open`,
        value: (record: ViewQueryRecordNode): string | undefined => record.id,
      },
    ]
  }, [enableNxOnlyFeature, pickedIds, query])
}
